import { color } from '@/colors';
import { hexToRgbaWithAlpha } from '@/utils/color.utils';
import type { PromptEditorContextMenuState } from './types';

// Regex pattern to match {{tagKey}}, {{tagKey:}}, or {{tagKey:tagValue}} in pasted text
// Captures: group 1 = tagKey, group 2 = optional tagValue (after the colon)
export const INPUT_TAG_PATTERN = /\{\{([a-zA-Z][a-zA-Z0-9]*)(?::([^}]*))?\}\}/g;
export const EMPTY_VALUE_TEXT = 'None';

// Tiptap node type for variable tags
export const VARIABLE_TAG_NAME = 'inlineTag';

// Special key and text for the @ mention trigger tag
export const MENTION_TAG_NAME = '@mention';
export const MENTION_TEXT = '@';

export const TAG_BACKGROUND_COLOR = hexToRgbaWithAlpha(color.DataType_Text, 0.24);
export const TAG_BACKGROUND_COLOR_HOVER = hexToRgbaWithAlpha(color.DataType_Text, 0.4);
export const TAG_BACKGROUND_COLOR_ACTIVE = hexToRgbaWithAlpha(color.DataType_Text, 0.64);
export const VALUE_COLOR = color.White100;
export const SOURCE_COLOR = color.DataType_Text;
export const EMPTY_VALUE_COLOR = color.White16_T;

export enum DisplayMode {
  SOURCE_VALUE = 'source-value',
  VALUE = 'value',
  SOURCE = 'source',
}

// CSS classes for tag elements
export const CSS_CLASSES = {
  EDITOR: 'tiptap-prompt-editor',
  TAG_CONTEXT_MENU_OPEN: 'tag-context-menu-open',
  TAG_SELECTED: 'tag-in-selection',
  TAG_DRAGGING: 'tag-dragging',
  TAG_LABEL: 'tag-label',
  TAG_VALUE: 'tag-value',
  TAG_VALUE_EMPTY: 'tag-value-empty',
} as const;

// Data attributes for tag elements
export const EDITOR_DATA_ATTR = {
  TAG_KEY: 'data-tag-key',
  TAG_LABEL: 'data-tag-label',
  TAG_VALUE: 'data-tag-value',
  TAG_IS_ITERATOR: 'data-tag-is-iterator',
  TAG_SHOW_LABEL: 'data-tag-show-label',
  TAG_SHOW_VALUE: 'data-tag-show-value',
} as const;

export const INITIAL_CONTEXT_MENU_STATE: PromptEditorContextMenuState = {
  type: 'closed',
  x: 0,
  y: 0,
};
